import { useAdminStore } from "@/store/useAdminStore";
import { Stage, Option, Item } from "@/types/productTypes";

export interface ListItemConfig<T> {
   type: "stage" | "option" | "item";
   getDisplayName: (item: T) => string;
   getSubItems?: (item: T) => any[];
   subListConfig?: ListItemConfig<any>;
   onSelect: (item: T, stageId?: number, optionId?: number) => void;
   onAdd: (productId: number, stageId?: number, optionId?: number) => void;
   canExpand: boolean;
}

const adminStore = useAdminStore.getState();

export const itemConfig: ListItemConfig<Item> = {
   type: "item",
   getDisplayName: (item) => item.name,
   onSelect: (item, stageId, optionId) =>
      adminStore.selectItem(stageId!, optionId!, item.id!),
   onAdd: (productId, stageId, optionId) =>
      adminStore.addItem(productId, stageId!, optionId!),
   canExpand: false,
};

export const optionConfig: ListItemConfig<Option> = {
   type: "option",
   getDisplayName: (option) => option.name,
   getSubItems: (option) => option.items,
   subListConfig: itemConfig,
   onSelect: (option, stageId) => adminStore.selectOption(stageId!, option.id!),
   onAdd: (productId, stageId) => adminStore.addOption(productId, stageId!),
   canExpand: true,
};

export const stageConfig: ListItemConfig<Stage> = {
   type: "stage",
   getDisplayName: (stage) => stage.header ?? "",
   getSubItems: (stage) => stage.options,
   subListConfig: optionConfig,
   onSelect: (stage) => adminStore.selectStage(stage.id!),
   onAdd: (productId) => adminStore.addStage(productId),
   canExpand: true,
};
